// 骁龙 APP 环境内
const xdragonBridge = {
  init: () => {
    // 骁龙 APP 环境内
    if (window.flutter_inappwebview) {
      // inappwebview 升级到 5.0.0 版本前的临时方案
      if (!window.flutter_inappwebview.callHandler) {
        window.flutter_inappwebview.callHandler = (...args) => {
          const _callHandlerID = setTimeout(() => {})
          window.flutter_inappwebview._callHandler(
            args[0],
            _callHandlerID,
            JSON.stringify(Array.prototype.slice.call(args, 1))
          )
          return new Promise((resolve) => {
            window.flutter_inappwebview[_callHandlerID] = resolve
          })
        }
      }

      const ready = new Promise((resolve) => {
        window.addEventListener('flutterInAppWebViewPlatformReady', () => {
          resolve()
        })
      })

      window.xdragon = {
        callHandler(...params) {
          return ready.then(() =>
            window.flutter_inappwebview.callHandler
              .apply(window.flutter_inappwebview, params)
              .then((res) => {
                if (!res) return res
                if (res.error) return Promise.reject(res.error)
                return res.data
              })
          )
        },
      }
    } else {
      // 骁龙pc 环境
      var ua = window.navigator.userAgent
      var Agents = [
        'Android',
        'iPhone',
        'SymbianOS',
        'Windows Phone',
        'iPad',
        'iPod',
      ]
      var isPc = true
      for (var i = 0; i < Agents.length; i++) {
        if (ua.indexOf(Agents[i]) > 0 || ua.indexOf('Electron') < 0) {
          isPc = false
          break
        }
      }
      if (isPc) {
        window.xdragon = {
          callHandler: (name, params) => {
            return new Promise((resolve, reject) => {
              window.parent.postMessage({ name: name, params: params }, '*')

              function listenHandler(event) {
                window.removeEventListener('message', listenHandler)
                var data = JSON.parse(event.data)
                resolve(data)
              }

              window.addEventListener('message', listenHandler)
            })
          },
        }
      }
    }
  },
}

export default xdragonBridge
